"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducers = void 0;
var Authenthication = require("./Authentication");
var Pending = require("./Pending");
var Service = require("./Service");
var ServiceByUUID = require("./ServiceByUUID");
var ServiceManage = require("./ServiceManage");
var ServiceInApplication = require("./ServiceInApplication");
var ApplicationManage = require("./ApplicationManage");
var KeyTokenByUUIDAndSerID = require("./KeyTokenByUUIDAndSerID");
var KeyTokenByUUIDAndSerIDAndTokenId = require("./KeyTokenByUUIDAndSerIDAndTokenId");
var Application = require("./Application");
var ConfirmStatusApplication = require("./ConfirmStatusApplication");
var RegisterToken = require("./RegisterToken");
// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
exports.reducers = {
    authentication: Authenthication.reducer,
    pending: Pending.reducer,
    keyToken: KeyTokenByUUIDAndSerID.reducer,
    keyTokenByID: KeyTokenByUUIDAndSerIDAndTokenId.reducer,
    service: Service.reducer,
    serviceByUUIDModel: ServiceByUUID.reducer,
    serviceManage: ServiceManage.reducer,
    serviceInApplication: ServiceInApplication.reducer,
    applicationManage: ApplicationManage.reducer,
    application: Application.reducer,
    confirmStatusApplication: ConfirmStatusApplication.reducer,
    registerTokenModel: RegisterToken.reducer
};
//# sourceMappingURL=index.js.map